import { BikeProductPageDataType } from "./TransformTypes"

export type BikeTypeCategory = "standard" | "electric" | "electricTrikes"

/**
 * Determines the bike type category based on bike type and style
 * @param bike - Bike object with optional type and style properties
 * @returns Bike type category: "standard", "electric", or "electricTrikes"
 */
export const getBikeTypeCategory = (
  bike: BikeProductPageDataType | { type?: Array<string | null> | null; style?: Array<string | null> | null }
): BikeTypeCategory => {
  const bikeTypes = bike?.type
  const bikeStyle = bike?.style

  if (!bikeTypes || bikeTypes.length === 0) {
    return "standard"
  }

  const validTypes = bikeTypes.filter((t): t is string => t !== null).map((t) => t.toLowerCase())
  const validStyle = bikeStyle?.filter((s): s is string => s !== null).map((s) => s.toLowerCase()) || []

  if (validTypes.includes("electric")) {
    if (validStyle.includes("tricycle")) {
      return "electricTrikes"
    }
    return "electric"
  }

  return "standard"
}
